import { pick } from 'lodash'
import { createTransform } from 'redux-persist'
import { Organization } from 'store/api/organization/organization.interface'

export const persistQueryFiltersTransform = createTransform(
  (inboundState, key) => {
    if (key === 'queryFilters') {
      return pick(inboundState, 'startTs', 'endTs')
    }
    return inboundState
  },
  (outboundState, key) => {
    if (key === 'queryFilters') {
      return pick(outboundState, 'startTs', 'endTs')
    }
    return outboundState
  },
)

export const persistOrgTransform = createTransform(
  (inboundState, key) => {
    if (key === 'org') {
      return (inboundState as Organization)?.PK
    }
    return inboundState
  },
  (outboundState, key) => {
    if (key === 'org') {
      return { PK: outboundState }
    }
    return outboundState
  },
)

export const persistDataMigrationTransform = createTransform(
  // Inbound: loading from storage
  (inboundState: Record<string, unknown>) => {
    return inboundState
  },
  // Outbound: saving to storage - check for old persist data and migrate
  (outboundState: Record<string, unknown>, key) => {
    if (key !== 'session' || typeof window === 'undefined') {
      return outboundState
    }

    // Check if there's old persist data in localStorage
    const oldPersistData = window.localStorage.getItem('persist:persist')
    if (!oldPersistData) {
      return outboundState
    }

    try {
      const parsedPersistData = JSON.parse(oldPersistData)
      const sessionToken = parsedPersistData.sessionToken
        ? JSON.parse(parsedPersistData.sessionToken)
        : undefined
      const sessionTtl = parsedPersistData.sessionTtl
        ? JSON.parse(parsedPersistData.sessionTtl)
        : undefined
      const wasRememberMeSelected = parsedPersistData.wasRememberMeSelected
        ? JSON.parse(parsedPersistData.wasRememberMeSelected)
        : undefined

      // Only migrate if values exist and session doesn't already have them
      const updatedSessionState = {
        ...outboundState,
        ...(sessionToken !== undefined && !outboundState?.sessionToken && { sessionToken }),
        ...(sessionTtl !== undefined && !outboundState?.sessionTtl && { sessionTtl }),
        ...(wasRememberMeSelected !== undefined &&
          !outboundState?.wasRememberMeSelected && { wasRememberMeSelected }),
      }

      // Remove the old persist data after migration
      if (
        sessionToken !== undefined ||
        sessionTtl !== undefined ||
        wasRememberMeSelected !== undefined
      ) {
        window.localStorage.removeItem('persist:persist')
      }

      return updatedSessionState
    } catch (error) {
      // If parsing fails, just return the original state
      return outboundState
    }
  },
)
